import { RAZORPAY_CHECKOUT_SCRIPT_URL } from 'utils/constant.utils';

// Both places that start a payment (the preview screen and the project list on the welcome screen) load
// Razorpay's checkout script through this one function. Calls made while the script is still loading share
// the one request, so mounting both never adds the script twice.
let pendingLoad: Promise<boolean> | null = null;

export const loadRazorpayScript = (): Promise<boolean> => {
  if (window.Razorpay) return Promise.resolve(true);
  if (pendingLoad) return pendingLoad;

  pendingLoad = new Promise<boolean>((resolve) => {
    const script = document.createElement('script');
    script.src = RAZORPAY_CHECKOUT_SCRIPT_URL;
    script.onload = () => resolve(true);
    script.onerror = () => {
      console.error('Failed to load the Razorpay checkout script');
      // Taken out and forgotten, so the next call can try again.
      script.remove();
      pendingLoad = null;
      resolve(false);
    };
    document.body.appendChild(script);
  });
  return pendingLoad;
};
